// src/backendServices/broadcastingManagment/api_broadcastedMedia.ts

import   axios                 from 'axios';
import { API_URLS            } from '../urls';

import { BackendResponse     ,
         handleError         } from '../../dataTypes/backendServicesManagment/types';

import { BroadcastedMedia    } from '../../dataTypes/broadcastingManagment/types';

import { convertDateToString } from '../../dataTypes/timeManagment/utils';

export interface BackendResponse_BroadcastedMediaList  extends BackendResponse <BroadcastedMedia[]> {}


// Fonction pour récupérer les canaux de diffusion (actifs ou archivés)
export const getBroadcastedMediaList = async (
                                               broadcastingChannelId : number = 1,           // Numéro du canal, par défaut 1
                                               startingDate?         : Date,                 // Date de début pour filtrer les vidéos
                                               endingDate?           : Date,                 // Date de fin pour filtrer les vidéos
                                               withArchives          : boolean = false,      // Si true, on récupère les canaux archivés
                                             ): Promise<BackendResponse_BroadcastedMediaList> => {

  // Choix de l'URL en fonction de l'état des canaux (actifs ou archivés)
  const url = API_URLS.getBroadcastedMediaList;

  let parameters = `?broadcastingChannelId=${broadcastingChannelId}`

  if (startingDate)
   {
 // parameters += `&batchBeginningDateStr=${convertDateToString(startingDate, 'yyyy/MM/dd HH:mm:ss')}`;
	parameters += `&batchBeginningDateStr=${convertDateToString(startingDate, "yyyy/MM/dd HH:mm:ssxxx")}`;
   }

  if (endingDate)
   {
 // parameters += `&batchEndingStr=${convertDateToString(endingDate, 'yyyy/MM/dd HH:mm:ss')}`;
    parameters += `&batchEndingStr=${convertDateToString(endingDate, "yyyy/MM/dd HH:mm:ssxxx")}`;
   }

  if (withArchives)
   {
    parameters += `&withArchives=${withArchives}`;
   }

  const fullUrl = `${url}${parameters}`;


  const headers = {
 //   'User-Agent-Informations': `${userAgentInformations}`,
 //   'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse_BroadcastedMediaList = {
    code: 0,
    comment: "",
    payload: [],
  };
  

  try
   {
    const response = await axios.get(fullUrl, { headers: headers });


    if (response.status === 200)
          {
           const broadcastedMedias: BroadcastedMedia[] = response.data.map((broadcastedMedia: any): BroadcastedMedia => {

             return {

                id              : broadcastedMedia.id ?? 0,
                broadcastDate   : broadcastedMedia.broadcastDate ? new Date(broadcastedMedia.broadcastDate) : new Date(),
                mediaId         : broadcastedMedia.mediaId,
                status          : broadcastedMedia.status,
                actualStartTime : broadcastedMedia.actualStartTime ? new Date(broadcastedMedia.actualStartTime) : null,
                audioTrackIndex : broadcastedMedia.audioTrackIndex ?? null,
                loop            : broadcastedMedia.loop === true,
                // Sans lui, un « Lire maintenant » redevenait une tuile ordinaire au premier
                // rechargement après « Mettre à jour le programme ».
                priority        : broadcastedMedia.priority === true,
                archived        : broadcastedMedia.archived === true,
              };
            }
          )


      // ✅ TRI PAR DATE DE DIFFUSION CROISSANTE
      .sort((a : BroadcastedMedia, b : BroadcastedMedia) => {
        if (!a.broadcastDate) return 1;
        if (!b.broadcastDate) return -1;
        return a.broadcastDate.getTime() - b.broadcastDate.getTime();
      });
	  

	  
           result = {
                      code    : 1,
                      comment : "Récupération des vidéos diffusées réussie.",
                      payload : broadcastedMedias,
                    };
          }
     else {
           result = handleError<BroadcastedMedia[]>(-101, `Erreur lors de la récupération des canaux de diffusion : ${response.status}`);
          }
   }
  catch (error)
   {
    console.log(error);
    result = handleError<BroadcastedMedia[]>(-102, 'Network error');
   }

  return result;
};




// Fonction pour ajouter une vidéo diffusée à un canal
//////////////////////////////////////////////////

export interface BroadcastedMediaCreationPayload {
  broadcastedMediaId : number;
  // false quand admin-api a bien créé la ligne en BDD mais que le microservice ne l'a pas
  // programmée (statut 'not_scheduled' : fenêtre de diffusion déjà entièrement passée, chemin
  // vidéo introuvable, microservice injoignable). La vidéo existe, avec le statut 'failed' —
  // elle s'affichera "Non diffusé" au prochain reload(). L'appelant doit malgré tout rattacher
  // broadcastedMediaId à son item local, sinon celui-ci reste id=0/tag="to create" et se
  // retrouve affiché en double (cf. notScheduledResponse() côté admin-api).
  scheduled          : boolean;
}

export const addBroadcastedMedia = async ( broadcastingChannelId : number           ,
                                           broadcastedMedia      : BroadcastedMedia ): Promise<BackendResponse<BroadcastedMediaCreationPayload>> => {

  const url = `${API_URLS.addBroadcastedMedia}`;

  const headers = {};

  let result: BackendResponse<BroadcastedMediaCreationPayload> = {
    code    : 0,
    comment : "",
    payload : { broadcastedMediaId: 0, scheduled: false }
  };

  // Paramètres pour la requête
  const broadcastingChannelIdStr: string = `${broadcastingChannelId}`;
  const mediaIdStr: string               = `${broadcastedMedia.mediaId}`;
  const broadcastDateStr: string         = convertDateToString (
                                                                 broadcastedMedia.broadcastDate,
                                                                 "yyyy/MM/dd HH:mm:ssxxx",  // "xxx" = +02:00 ou +01:00 selon DST
																 // 3ème argument : timezone courante autodétectée
                                                               );
  // "" (et non undefined) quand aucune piste n'a été choisie : admin-api traite une
  // chaîne vide comme null (comportement par défaut, première piste).
  const audioTrackIndexStr: string       = broadcastedMedia.audioTrackIndex !== null
                                            ? `${broadcastedMedia.audioTrackIndex}`
                                            : '';

  try
   {
    const response = await axios.post (
                                           url,
                                         {
                                           broadcastingChannelIdStr,
                                           mediaIdStr,
                                           broadcastDateStr,
                                           audioTrackIndexStr,
                                           loopStr : broadcastedMedia.loop ? '1' : '0',
                                           // admin-api prend alors SA propre heure et fait couper la vidéo en cours.
                                           priorityStr : broadcastedMedia.priority ? '1' : '0',
                                         },
                                         {
                                           headers: headers,
                                         }
                                      );

    if (response.status === 200)
          {
           // BroadcastedMediaCreation3 (admin-api) répond en HTTP 200 (pas 201) via $this->json(),
           // et renvoie toujours broadcasted_media_id (canal actif ou non) : indispensable pour que
           // le front puisse remplacer l'id local 0 par l'id réel et arrêter de retaguer l'item
           // "to create", sans quoi il est resoumis (et redupliqué en BDD) à chaque sauvegarde.
           // 'not_scheduled' : ligne bien créée en BDD, mais non programmée par le microservice.
           // On renvoie quand même code 1 — la création a réussi, et l'appelant DOIT rattacher
           // l'id pour ne pas garder un item local fantôme à côté de la ligne serveur.
           const notScheduled = response.data?.status === 'not_scheduled';

           if (notScheduled) {
             console.warn(
               `[programmation] vidéo créée (#${response.data?.broadcasted_media_id}) mais non programmée par le microservice : ${response.data?.error}`,
               response.data?.details
             );
           }

           result = {
                      code: 1,
                      comment: notScheduled ? "Ajout effectué, sans programmation" : "Ajout effectué",
                      payload : {
                                  broadcastedMediaId : response.data?.broadcasted_media_id ?? 0,
                                  scheduled          : !notScheduled,
                                }
                    };
          }
     else {
           // Si le statut n'est pas 200, gérer l'erreur
           return handleError<BroadcastedMediaCreationPayload>(response.status, "Erreur lors de l'ajout de la vidéo à diffuser");
          }
   }
  catch (error)
   {
    console.log(error);

    if (axios.isAxiosError(error))
     {
      // 422 'refused' : admin-api a contrôlé le fichier vidéo AVANT toute création et l'a jugé
      // introuvable — sa diffusion échouerait. Aucune ligne n'existe en base : l'appelant doit
      // RETIRER l'item local (id=0) de la playlist, faute de quoi il serait resoumis, et refusé
      // à nouveau, à chaque « Mettre à jour le programme ». Le code 422 le distingue d'une
      // panne réseau ou serveur (-101), où l'item doit au contraire rester pour un nouvel essai.
      if (error.response?.status === 422 && error.response.data?.status === 'refused')
       {
        return handleError<BroadcastedMediaCreationPayload>(422, error.response.data.error ?? "Vidéo non diffusable : refusée par le serveur");
       }

      return handleError<BroadcastedMediaCreationPayload>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<BroadcastedMediaCreationPayload>(-102, "Erreur inconnue");
   }

  return result;
};


// Fonction pour mettre à jour une vidéo diffusée
//////////////////////////////////////////////////

export interface BroadcastedMediaUpdatePayload {
  // false quand admin-api a bien mis à jour la ligne en BDD mais que le microservice n'a
  // pas pu la reprogrammer (statut 'not_rescheduled' : fenêtre déjà passée, chemin vidéo
  // introuvable, microservice injoignable). ⚠️ La vidéo a alors été RETIRÉE du planning par
  // l'étape 1 de la reprogrammation et n'y est pas revenue : elle ne sera pas diffusée,
  // alors qu'elle reste 'queued' en BDD et s'affiche "En attente". L'appelant doit le
  // signaler — jusqu'ici ce cas était renvoyé en HTTP 200 'success' et totalement silencieux.
  rescheduled : boolean;
}

export const updateBroadcastedMedia = async ( broadcastingChannelId : number           ,
                                              broadcastedMedia      : BroadcastedMedia ): Promise<BackendResponse<BroadcastedMediaUpdatePayload>> => {

  // Construction dynamique de l'URL
  const baseUrl = `${API_URLS.updateBroadcastedMedia}`;
  const url = baseUrl.replace("{id}", `${broadcastedMedia.id}`);

  const headers = {
  //  'User-Agent-Informations': `${userAgentInformations}`,
  //  'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse<BroadcastedMediaUpdatePayload> = {
    code    : 0,
    comment : "",
    payload : { rescheduled: false }
  };

  const broadcastingChannelIdStr : string = `${broadcastingChannelId}`;
  const mediaIdStr               : string = `${broadcastedMedia.mediaId}`;
  const broadcastDateStr         : string = convertDateToString (
                                                                  broadcastedMedia.broadcastDate,
                                                                  "yyyy/MM/dd HH:mm:ssxxx",  // "xxx" = +02:00 ou +01:00 selon DST
                                                                  // 3ème argument : timezone courante autodétectée
                                                                );
  const audioTrackIndexStr       : string = broadcastedMedia.audioTrackIndex !== null
                                             ? `${broadcastedMedia.audioTrackIndex}`
                                             : '';

  try
   {

    const response = await axios.patch (
                                            url ,
                                         {
                                            broadcastingChannelIdStr,
                                            mediaIdStr,
                                            broadcastDateStr,
                                            audioTrackIndexStr,
                                         },
                                         {
                                            headers: headers,
                                         }
                                       );

    const statut = response.status;

    if (statut === 200)
          {
           // 'not_rescheduled' : la BDD est à jour mais la vidéo n'est plus dans le planning
           // du microservice. On renvoie quand même code 1 — la mise à jour a réussi, c'est
           // la programmation qui a échoué — mais l'appelant doit en avertir l'utilisateur.
           const notRescheduled = response.data?.status === 'not_rescheduled';

           if (notRescheduled) {
             console.warn(
               `[programmation] vidéo #${broadcastedMedia.id} mise à jour mais NON reprogrammée : ${response.data?.error}`,
               response.data?.details
             );
           }

           result = {
                      code    : 1,
                      comment : notRescheduled ? "Modification effectuée, sans reprogrammation" : "Modification effectuée",
                      payload : { rescheduled: !notRescheduled }
                    };
          }
     else {
           return handleError<BroadcastedMediaUpdatePayload>(response.status, "Erreur lors de la modification de la vidéo à diffuser", { rescheduled: false });
          }

   }
  catch (error)
   {
    console.log(error);

    // Gestion des erreurs Axios
    if (axios.isAxiosError(error))
     {
      return handleError<BroadcastedMediaUpdatePayload>(-101, error.response?.data?.detail ?? error.message, { rescheduled: false });
     }

    // Gestion des erreurs génériques
    return handleError<BroadcastedMediaUpdatePayload>(-102, "Erreur inconnue", { rescheduled: false });
   }

  return result;
};


// « Jouer en boucle » : arme/désarme la boucle d'un programme déjà enregistré
//////////////////////////////////////////////////

export interface BroadcastedMediaLoopPayload {
  // Fin du tour en cours quand le programme est à l'antenne (null sinon, ou si le
  // microservice n'a pas répondu) : à la désactivation, les programmes suivants y repartent.
  cycleEnd : Date | null;
  // false quand la chaîne est inactive ou que le microservice n'a pas répondu : la BDD
  // fait alors foi, la boucle sera transmise à la prochaine activation.
  synced   : boolean;
}

export const setBroadcastedMediaLoop = async ( broadcastedMediaId : number  ,
                                               loop               : boolean ): Promise<BackendResponse<BroadcastedMediaLoopPayload>> => {

  const url = `${API_URLS.setBroadcastedMediaLoop}`.replace("{id}", `${broadcastedMediaId}`);

  try
   {
    const response = await axios.patch ( url, { loopStr : loop ? '1' : '0' } );

    if (response.status === 200)
     {
      return {
               code    : 1,
               comment : "Boucle mise à jour",
               payload : {
                           cycleEnd : response.data?.cycle_end ? new Date(response.data.cycle_end) : null,
                           synced   : response.data?.microservice_sync === true,
                         }
             };
     }

    return handleError<BroadcastedMediaLoopPayload>(response.status, "Erreur lors du réglage de la boucle", { cycleEnd: null, synced: false });
   }
  catch (error)
   {
    console.log(error);

    if (axios.isAxiosError(error))
     {
      return handleError<BroadcastedMediaLoopPayload>(-101, error.response?.data?.error ?? error.message, { cycleEnd: null, synced: false });
     }

    return handleError<BroadcastedMediaLoopPayload>(-102, "Erreur inconnue", { cycleEnd: null, synced: false });
   }
};


// Fonction pour supprimer une vidéo diffusée
//////////////////////////////////////////////////

export const deleteBroadcastedMedia = async ( broadcastedMediaId: number          , 
                                              recalculate:        boolean = false ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.deleteBroadcastedMedia}`;
  const url = baseUrl.replace("{id}", `${broadcastedMediaId}`);
  const finalUrl = `${url}${recalculate ? '?recalculateSchedule=true' : ''}`

  const headers = {
//    'User-Agent-Informations': `${userAgentInformations}`,
//    'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse = {
    code    : 0,
    comment : "",
    payload : {} as any
  };

  try
   {

    const response = await axios.delete ( finalUrl, { headers: headers });

    const statut = response.status;

    if (statut === 204)
          {
           result = {
                      code: 1,
                      comment: "Suppression effectuée",
                      payload : {} as any
                    };
          }
     else {
           return handleError<void>(response.status, `Erreur lors de l'archivage de la vidéo diffusée : ${response.status}`);
          }
   }
  catch (error)
   {
    console.log(error);

    // Gestion des erreurs Axios
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    // Gestion des erreurs génériques
    return handleError<void>(-102, "Erreur inconnue");
   }

  return result;
};


// Fonction pour archiver une vidéo diffusée
//////////////////////////////////////////////////

export const archiveBroadcastedMedia = async ( broadcastedMediaId: number ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.archiveBroadcastedMedia}`;
  const url = baseUrl.replace("{id}", `${broadcastedMediaId}`);

  const headers = {
//    'User-Agent-Informations': `${userAgentInformations}`,
//    'App-Informations': `${appInformations}`,
  };

  let result: BackendResponse = {
    code    : 0,
    comment : "",
    payload : {} as any
  };

  try
   {

    const response = await axios.delete ( url, { headers: headers });

    const statut = response.status;

    if (statut === 204)
          {
           result = {
                      code: 1,
                      comment: "Archivage effectué",
                      payload : {} as any
                    };
          }
     else {
           return handleError<void>(response.status, `Erreur lors de l'archivage de la vidéo diffusée : ${response.status}`);
          }
   }
  catch (error)
   {
    console.log(error);

    // Gestion des erreurs Axios
    if (axios.isAxiosError(error))
     {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }

    // Gestion des erreurs génériques
    return handleError<void>(-102, "Erreur inconnue");
   }

  return result;
};
